const STATUSES = [["new", "New"], ["quoted", "Quoted"], ["accepted", "Accepted"], ["done", "Done"], ["declined", "Declined"]];

export const RequestCard = ({ r, onStatus, busy }) => (
  <article data-testid={`admin-request-${r.reference}`} className="rounded-[24px] chunk bg-white p-5 sm:p-6">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <p className="font-mono-x font-bold text-lg">{r.reference}</p>
        <p className="text-sm text-[#5a5470]">{new Date(r.created_at).toLocaleString("en-NZ")}</p>
      </div>
      <select data-testid={`admin-request-status-${r.reference}`} value={r.status} disabled={busy}
        onChange={(e) => onStatus(r, e.target.value)}
        className="rounded-full border-2 border-[var(--ink)] px-3 py-2 font-semibold text-sm bg-[var(--yellow)]">
        {STATUSES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
    <p className="font-bold mt-4">{r.name} · <a className="underline font-normal break-all" href={`mailto:${r.email}`}>{r.email}</a></p>
    <p className="mt-2 whitespace-pre-wrap">{r.idea}</p>
    <dl className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4 text-sm">
      {[["Colours", r.colors], ["Size", r.size], ["Budget", r.budget], ["Needed by", r.deadline]].map(([k, v]) => (
        <div key={k}><dt className="text-[#5a5470]">{k}</dt><dd className="font-semibold">{v || "-"}</dd></div>
      ))}
    </dl>
  </article>
);
